import React from 'react';

import {useTheme} from "@mui/material";
import MDBox from "../MDBox";

const PreviewTabs = ({ value, onChange, tabs }) => {
    const theme = useTheme();
    const primaryColor = theme.palette.info.main;

    return (
        <MDBox sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            px: 0.25,
            pr: 3,
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            flexShrink: 0,
            borderBottom: '1px solid',
            borderColor: 'divider',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        }}>
            {tabs.map((tab) => {
                const isActive = value === tab.value;
                return (
                    <MDBox
                        key={tab.value}
                        onClick={() => onChange(tab.value)}
                        sx={{
                            py: 0.5,
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: isActive ? 600 : 400,
                            color: isActive ? primaryColor : '#9ca3af',
                            borderBottom: isActive ? `2px solid ${primaryColor}` : '2px solid transparent',
                            marginBottom: '-1px',
                            transition: 'all 0.18s ease',
                            userSelect: 'none',
                            whiteSpace: 'nowrap',
                            '&:hover': !isActive ? {
                                color: primaryColor,
                                opacity: 0.7,
                            } : {},
                        }}
                    >
                        {tab.label}
                    </MDBox>
                );
            })}
        </MDBox>
    );
};

export default PreviewTabs;
